module.exports = __webpack_public_path__ + "static/media/screenshot(48).e79c91c2.jpg";